export const legacyTypes = {
  LIST_LEGACY: 'LIST_LEGACY_MODEL',
  LIST_LEGACY_SUCCESS: 'LIST_LEGACY_MODEL_SUCCESS',
  LIST_LEGACY_FAIL: 'LIST_LEGACY_MODEL_FAIL',
  
};
